import { Text } from '@mantine/core';

type Props = {
  label: string;
};

/** Libellé suivi d'un astérisque, pour un `Switch` obligatoire (sans l'attribut HTML `required`). */
const SusRequiredLabel = ({ label }: Props) => (
  <>
    {label}
    <Text component="span" inherit c="var(--mantine-color-error)" aria-hidden>
      {' *'}
    </Text>
  </>
);

export default SusRequiredLabel;
